import { Image, ImageBackground, Linking, Platform, StyleSheet, TouchableOpacity, View } from 'react-native'
import Share from 'react-native-share'
import { observer } from 'mobx-react-lite'
import { SvgProps } from 'react-native-svg'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
//import { captureRef } from 'react-native-view-shot'
import { DS } from '../../design-system'
import { ThreeCardTop } from './ThreeCardTop'
import { palette } from '../../theme/palette'
import { useStore } from '../../models'

import ShareBackground from './assets/ShareBackground.png'
import Copy from './assets/Copy.svg'
import Messages from './assets/Messages.svg'
import More from './assets/More.svg'
import Story from './assets/Story.svg'

import PokerPowerLogo from '../../../assets/mainHeader/poker-power-logo.png'
import Chip from '../../components/ANewDesign/assets/Chips.svg'
import { useEffect, useRef, useState } from 'react'

function getToday() {
  const today = new Date()
  const month = today.toLocaleString('default', { month: 'long' })
  const day = today.getDate()
  return `${month} ${day}`
}

export const ThreeCardShareScreen = observer(() => {
  const FACEBOOK_APP_ID = process.env.EXPO_PUBLIC_FACEBOOK_APP_ID || ''

  const insets = useSafeAreaInsets()
  const ref = useRef(null)
  const {
    game: { getThreeCardResult, threeCardResult },
    session: { user }
  } = useStore()

  useEffect(() => {
    if (!threeCardResult?.length) (async () => await getThreeCardResult())()
  }, [getThreeCardResult, threeCardResult])

  const [hasInstagramInstalled, setHasInstagramInstalled] = useState(false) // State to track if Instagram is installed on user's device or not

  // useEffect(() => {
  //   if (Platform.OS === 'ios') {
  //     Linking.canOpenURL('instagram://').then((val) => setHasInstagramInstalled(val))
  //   } else {
  //     Share.isPackageInstalled('com.instagram.android').then(({ isInstalled }) => setHasInstagramInstalled(isInstalled))
  //   }
  // }, [])

  if (!(threeCardResult && user)) return null

  async function captureAndShare() {
    try {
      // Capture the screenshot of the element and store it into the uri variable
      //   const uri = await captureRef(ref, {
      //     format: 'png',
      //     quality: 1
      //   })
      //   if (hasInstagramInstalled) {
      //     await Share.shareSingle({
      //       appId: FACEBOOK_APP_ID, // Note: replace this with your own appId from facebook developer account, it won't work without it. (https://developers.facebook.com/docs/development/register/)
      //       stickerImage: uri,
      //       social: Share.Social.INSTAGRAM_STORIES,
      //       backgroundBottomColor: '#1D1D1D', // You can use any hexcode here and below
      //       backgroundTopColor: '#1D1D1D',
      //       backgroundImage: '...' // This field is optional like the other fields (except appId) and you have to put a base64 encoded image here if you want to use it!
      //     })
      //   } else {
      //     // If instagram is not installed in user's device then just share using the usual device specific bottomsheet (https://react-native-share.github.io/react-native-share/docs/share-open)
      //     await Share.open({ url: uri })
      //   }
    } catch (error) {
      // console.error(error)
    }
  }

  const myResult = threeCardResult.map((result) => result.players?.find((p) => p.name === user.name))

  const myResultGraph = myResult.map((result, i) => {
    const previousResult = i === 0 ? 5000 : myResult[i - 1]?.chips
    if (!result) return 0
    return (result.chips ?? 0) - (previousResult ?? 0)
  })

  return (
    <View style={{ flex: 1 }}>
      <View style={[styles.container, { paddingTop: insets.top * 2 }]}>
        <ThreeCardTop end />
        <View style={styles.titleContainer}>
          <DS.Text variant="Heading 2/Medium">Share your win card</DS.Text>
        </View>
        <ImageBackground
          ref={ref}
          source={ShareBackground}
          resizeMode="contain"
          style={{ flex: 2.5, justifyContent: 'center', padding: 10, width: '100%' }}
        >
          <View
            style={{ flex: 0.9, backgroundColor: DS.palette['Global/White'], padding: 10, borderRadius: 8, gap: 20 }}
          >
            <Image source={PokerPowerLogo} style={{ flex: 0.3, width: '100%' }} resizeMode="contain" />
            <View style={{ flex: 0.1, flexDirection: 'row', justifyContent: 'center', gap: 10 }}>
              <DS.Text variant="Caption/Bold">DAILY 3-CARD POKER</DS.Text>
              <DS.Text variant="Caption/Medium">{getToday()}</DS.Text>
            </View>
            <View style={{ flex: 1, gap: 5 }}>
              {myResultGraph.map((result, i) => (
                <GraphRow key={`GraphRow-${i}`} result={result} />
              ))}
            </View>
            <View
              style={{
                flex: 0.4,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#DEF3FF',
                borderRadius: 8
              }}
            >
              <DS.Text variant="Heading 4/Medium">Total Chips</DS.Text>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Chip />
                <DS.Text variant="Body Large/Medium">{myResult.at(-1)?.chips}</DS.Text>
              </View>
            </View>
          </View>
        </ImageBackground>
        <View style={styles.actionsContainer}>
          <ActionButton text="Messages" Icon={Messages} onPress={() => alert('Messages')} />
          <ActionButton text="Story" Icon={Story} onPress={captureAndShare} />
          <ActionButton text="Copy" Icon={Copy} onPress={() => alert('Copy')} />
          <ActionButton text="More" Icon={More} onPress={() => alert('More')} />
        </View>
      </View>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: palette.cream,
    justifyContent: 'space-between',
    padding: 30
    // alignItems: 'center',
  },
  titleContainer: {
    marginTop: 15,
    flex: 0.2,
    alignItems: 'center'
  },
  content: {
    flex: 1
  },
  actionsContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-around'
  }
})

interface ActionButtonProps {
  text: string
  Icon: React.FC<SvgProps>
  onPress: () => void
}

const ActionButton = ({ text, Icon, onPress }: ActionButtonProps) => {
  return (
    <TouchableOpacity onPress={onPress}>
      <Icon />
      <DS.Text variant="Mini/Medium" style={{ textAlign: 'center' }}>
        {text}
      </DS.Text>
    </TouchableOpacity>
  )
}

const MAX_AMOUNT_OF_CHIPS = 2500

const GraphRow = ({ result }: { result: number }) => {
  const text = result === 0 ? '0' : result > 0 ? `+${result}` : result

  return (
    <View style={[graphStyles.container, { flexDirection: result >= 0 ? 'row-reverse' : 'row' }]}>
      <View style={[{ width: result === 0 ? '100%' : '50%' }]}>
        <View
          style={[
            graphStyles.box,
            {
              alignSelf: result === 0 ? 'center' : result > 0 ? 'flex-start' : 'flex-end',
              backgroundColor: result > 0 ? DS.palette['Brand/Blue'] : DS.palette['Brand/Light Grey'],
              minWidth: 40,
              width: result === 0 ? '10%' : `${(Math.abs(result) * 100) / MAX_AMOUNT_OF_CHIPS}%`
            }
          ]}
        >
          <DS.Text variant="Caption/Bold" color={result > 0 ? 'Global/White' : 'Brand/Dark Grey'}>
            {text}
          </DS.Text>
        </View>
      </View>
    </View>
  )
}

const graphStyles = StyleSheet.create({
  container: {
    flex: 1
  },
  rightOrLeft: {
    width: '50%'
  },
  box: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8
  }
})
